<template>
    <Modal name="somethingWentWrong" v-bind="$attrs" :key='id' size="w-screen h-screen md:h-auto md:max-w-3xl md:w-6/12 md:rounded-3xl">
        <template v-slot:header>
            <h1>{{ $t('warning') }}</h1>
        </template>
        <template v-slot:body>
            <div class="grid grid-cols-1 sm:grid-cols-1 sm:gap-x-8">
              <p>{{ $t('something_went_wrong') }}</p>
            </div>
        </template>
        <template v-slot:footer>
            <div class="btn btn-primary submit" @click="$attrs.close">
                OK
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '../modules/modals/components/Modal'

export default {
    name: 'modalSomethingWentWrong',
    components: {
        Modal,
    }
}
</script>

<style lang="sass" scoped>
h1
    font-size: 25px!important
</style>